export default function HCPDashboard() {
  return (
    <div>
      <h1>Dashboard HCP</h1>
      <p>Bem-vindo ao módulo HCP.</p>
    </div>
  );
}
